// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crewtarget-widget{width:100%;display:flex;flex-direction:row;overflow:hidden}.crewtarget-widget span{padding:18px;color:#fff;flex-grow:1;flex-basis:0;text-align:center;font-size:42px;font-weight:bold}.crewtarget-widget span:first-child{background:#fa0019}.crewtarget-widget span:nth-child(2){background:#198216}", ""]);
// Exports
module.exports = exports;
